import { render, staticRenderFns } from "./MatchingAdminTable.vue?vue&type=template&id=a6342fdc&"
import script from "./MatchingAdminTable.vue?vue&type=script&lang=js&"
export * from "./MatchingAdminTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchingAdminTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports